
import DefaultController from '../../controller';

import {cloneObject} from '../../functions';

class Controller extends DefaultController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.type = 'textbox';

        this.textHeight = 0;
        this.shortened = false;
        this.vOffset = 0;
        this.updateCycle = 0;

    }
   
    init(renderer){
        super.init(renderer);

        this.setText();
    }

    render(renderer){
        super.render(renderer);

        if(this.updateCycle < 10){
            this.updateLayout();
            this.updateCycle++;
            this.update();
            this.trigger('textHeight', [this.textHeight]);
        }else if(this.updateCycle == 10){
            if(this.shortened){
                this.trigger('shortened', [true]);
            }else{
                this.trigger('shortened', [false]);
            }
            this.trigger('textHeight', [this.textHeight]);
        }

    }

    setText(noBreak=false){

        let text = this.data.text || '';
        this.updateCycle = 0;
    
        while (this.renderOutput.result.firstChild) {
            this.renderOutput.result.removeChild(this.renderOutput.result.firstChild);
        }

        let words = [text]; // why convert to array...?
        if(! noBreak){
            words = text.toString().split(' ');
        }
        let x = 0;
        let y = 0;
            
        for(let i = 0; i < words.length; i++){
            let tspanEl = document.createElementNS('http://www.w3.org/2000/svg', "tspan");
            tspanEl.setAttributeNS('',"x", 0);
            tspanEl.setAttributeNS('',"dy", 0);
            if(! noBreak){
                tspanEl.setAttributeNS('',"style", 'visibility: hidden');
            }
            tspanEl.textContent = words[i] + ' ';
            this.renderOutput.result.appendChild(tspanEl);
        }
        
    }

    updateLayout(){
       
        this.shortened = false;

        let i = 0;
        while(i < this.renderOutput.result.childNodes.length){
            let className = this.renderOutput.result.childNodes[i].getAttributeNS('', 'class');
            if(className == 'more'){
                this.renderOutput.result.removeChild(
                        this.renderOutput.result.childNodes[i]);
            }else{
                i++;
            }
        }

        let nodes = this.renderOutput.result.childNodes;
        let x = 0;
        let y = 0;
        let top = 0;
        let w = 0;
        let textBreak = false;

        for(let i = 0; i < nodes.length; i++){
            if(top + this.data.lineHeight > this.data.height || textBreak != false){
                textBreak = nodes[i];
                w = (! w)? 0: w;
                nodes[i].setAttributeNS('',"style", 'visibility: hidden');
                nodes[i].setAttributeNS('',"x", -1);
                nodes[i].setAttributeNS('',"dy", 0);
                continue;
            }
            if(nodes[i].textContent == '{{br}} '){
                y = this.data.lineHeight;
                top += y;
                nodes[i].setAttributeNS('',"style", 'visibility: hidden');
                nodes[i].setAttributeNS('',"x", -1);
                nodes[i].setAttributeNS('',"dy", 0);
                if(top + this.data.lineHeight > this.data.height){
                    top -= y;
                }
                x = 0;
                continue;
            }
            try{
                w = nodes[i]['getComputedTextLength'](); 
            }catch(e){
                continue;
            }
            if(w && w > 0){
                if(x+w > this.data.width /* && x > 0 */){
                    // add a new line
                    y = this.data.lineHeight;
                    top += y;
                    if(top + this.data.lineHeight > this.data.height){
                        textBreak = nodes[i];
                        if(this.data.breakWord && this.updateCycle > 8){
                            let room = this.data.width - x - 12;
                            if(room > 20){
                                nodes[i].setAttributeNS('', "style", 'visibility: visible');
                                nodes[i].setAttributeNS('', "x", x);
                                nodes[i].setAttributeNS('', "dy", 0);
                                let letters = Math.round(room/w * nodes[i].textContent.length)
                                nodes[i].textContent = nodes[i].textContent.substring(0, letters);
                                x = this.data.width - 12;
                            }
                        }else{
                            nodes[i].setAttributeNS('', "style", 'visibility: hidden');
                            nodes[i].setAttributeNS('', "x", -1);
                            nodes[i].setAttributeNS('', "dy", 0);
                        }
                        top -= y;
                        continue;
                    }else if(w > this.data.width && this.data.breakWord){   // the single word doesn't fit
                        // todo: if there is space in height, we want to break a word in two
                        // and continue on next line. Now we just quit here.
                        textBreak = nodes[i];
                        if(this.updateCycle > 8){
                            let room = this.data.width - 12;
                            if(room > 20){
                                nodes[i].setAttributeNS('', "style", 'visibility: visible');
                                nodes[i].setAttributeNS('', "x", x);
                                nodes[i].setAttributeNS('', "dy", 0);
                                let letters = Math.round(room/w * nodes[i].textContent.length)
                                nodes[i].textContent = nodes[i].textContent.substring(0, letters);
                                x = this.data.width - 12;
                            }
                        }
                        break;
                    }
                    x = 0;
                }
                nodes[i].setAttributeNS('', "x", x);
                nodes[i].setAttributeNS('', "dy", y);
                // todo: chrome may not update these changes immidiatly
                nodes[i].setAttributeNS('', "style", 'visibility: visible');
                x += w;
                y = 0;
            }else{
                textBreak = false;
            }
        }

        this.textHeight = top + this.data.lineHeight;

        if(textBreak != false){
            let dots = document.createElementNS('http://www.w3.org/2000/svg', "tspan");
            dots.setAttributeNS('',"x", x);
            dots.setAttributeNS('',"dy", 0);
            dots.setAttributeNS('','class', 'more');
            dots.textContent = '...';
            this.renderOutput.result.appendChild(dots);
            this.shortened = true;
        }
        if(this.data.alignment != 'left' || this.data.verticalAlign != 'top'){
            this.align();
        }
    }


    align(){
        let direction = this.data.alignment;
        let nodes = this.renderOutput.result.childNodes;
        let width = 0;
        let start = 0;
        let curIndex = 0;
        for(let i = 0; i < nodes.length; i++){
            let x = parseFloat(nodes[i].getAttributeNS('', 'x'));
            if(x < 0){
                continue;
            }
            let y = parseFloat(nodes[i].getAttributeNS('', 'dy'));
            if(y > 0 && i > 0){
    //            width += nodes[i-1].getComputedTextLength();
                this.applyAlignment(width, nodes, i-1, start, direction, curIndex);
                curIndex = i;
                start = 0;
                width = 0;
            }
            // this doesn't work the way it should.
            // if(width == 0 && x > 0){
    //            start = x;
            // }
            width = x;
        }
        this.applyAlignment(width, nodes, nodes.length-1, start, direction, curIndex);
        
        let offset = 0;
        if(this.data.verticalAlign == 'bottom'){
            offset = this.data.height - this.textHeight;
        }else if(this.data.verticalAlign == 'middle'){
            offset = 0.5 * (this.data.height - this.textHeight);
        }

        // let transform = this.getTransformation();
        // transform.setPosition(transform.position.x, 
        //         transform.position.y - this.vOffset + offset);
        if(offset !== this.vOffset){
            this.vOffset = offset;
            this.update();
        }
    }

    applyAlignment(width, nodes, i, start, direction, curIndex){
        if(parseFloat(nodes[i].getAttributeNS('', 'x')) >= 0){
            try{
                width += nodes[i]['getComputedTextLength']();
            }catch(e){
                
            }
        }else if(i>0 && parseFloat(nodes[i-1].getAttributeNS('', 'x')) >= 0){
            try{
                width += nodes[i-1]['getComputedTextLength']();
            }catch(e){
                
            }
        }
        let offset = this.data.width - width;

        if(direction == 'left'){
            offset = -1 * start;
        }else if(direction == 'center'){
            offset = 0.5 * (offset + start) - start;
        }
        for(let t = curIndex; t <= i; t++){
            let tx = parseFloat(nodes[t].getAttributeNS('', 'x'));
            if(tx >= 0){
                nodes[t].setAttributeNS('', 'x', tx + offset);
            }
        }
    }
  


}

// you can extend a blue print for a parent component by importing it
// and using let Blueprint = Object.assign(parentBlueprint, {my: 'settings'});

let Blueprint = {
    type: Controller,
    properties: { 
        style: { },
        data: {
            width: 200,
            height: 20,
            lineHeight: 20,
            textHeight: 0,      
            alignment: 'left',
            verticalAlign: 'top',
            text: '',
            breakWord: false
        },
      },
    events: {   },
    children: []
}

export default Blueprint;
export {Controller};
